// ** React Imports
import { ChangeEvent, useMemo } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'


// ** Custom Avatar Component
import CustomAvatar from 'src/@core/components/mui/avatar'

import { RootState} from 'src/store'
import { useSelector } from 'react-redux'
import axios from 'src/services/ApiService';

interface TabDetails {
    setMedium: (arg0: number) => void
    setMediumName: (arg0: string) => void
    medium: number
    mediumName : string
}

const TabDetails = (props: TabDetails) => {
    const { medium, setMedium, mediumName, setMediumName } = props;
    const store = useSelector((state: RootState) => state.lookup)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        updateMedium(event.target.value);
    }

    const updateMedium = (name: string) => {
        let selectedMedium = store.data.mediums.filter(p => p.name == name)[0];
        if (selectedMedium) {
            setMedium(selectedMedium.id)
            setMediumName(selectedMedium.name)
        }
    }


    const isSelectedMedium = (name: string): boolean => {
        //console.log("mediums:",store.data.mediums)

        let selectedMedium = store.data.mediums.filter(p => p.name == name)[0];
        return selectedMedium ? medium == selectedMedium.id : false;
    }

    function createAndSubmitForm(providerName: string) {

        var form = document.createElement('form');
        form.setAttribute('method', 'get');
        form.setAttribute('action', '/Identity/Account/ExternalLogin/ExternalClaimProvider?provider=' + providerName);
        form.style.display = 'none'; // Hide the form to avoid changing the page layout

        var returnUrlInput = document.createElement('input');
        returnUrlInput.setAttribute('type', 'hidden');
        returnUrlInput.setAttribute('name', 'returnUrl');
        returnUrlInput.setAttribute('value', '');
        form.appendChild(returnUrlInput);

        var providerInput = document.createElement('input');
        providerInput.setAttribute('type', 'hidden');
        providerInput.setAttribute('name', 'provider');
        providerInput.setAttribute('value', providerName);
        form.appendChild(providerInput);

        document.body.appendChild(form);

        form.submit();

        setTimeout(() => form.remove(), 100);
    };
    //TODO|SMMP Localize/Download Image assets, Make caption statements as constants
    return (
        <Box>
            <Typography variant='h6' sx={{ mb: 4 }}>
                Category
            </Typography>
            <Box sx={{ mb: 8 }}>
                <Box
                    onClick={() => updateMedium('Facebook')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/color/32/facebook-new.png" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Facebook</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add Facebook Pages and Groups to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Facebook' onChange={handleChange} checked={isSelectedMedium("Facebook")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Google')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/color/32/google-logo.png" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Google</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Manage applications like Youtube by integrating your business account with google.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Google' onChange={handleChange} checked={isSelectedMedium("Google")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Pinterest')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=63676&format=png" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Pinterest</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Manage Pins by integrating your business account with Pinterest.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Pinterest' onChange={handleChange} checked={isSelectedMedium("Pinterest")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Instagram')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=Xy10Jcu1L2Su&format=png" alt="Instagram" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Instagram</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Manage posts by integrating your business account with Instagram.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Instagram' onChange={handleChange} checked={isSelectedMedium("Instagram")} />
                </Box>
                <Box
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='primary' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=118640&format=png" alt="TikTok" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>TikTok</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Manage your content by integrating with TikTok.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='TikTok' onChange={handleChange} checked={isSelectedMedium("TikTok")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Threads')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=AS2a6aA9BwK3&format=png&color=000000" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Threads</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add Threads accounts to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Threads' onChange={handleChange} checked={isSelectedMedium("Threads")} />
                </Box>
                <Box
                    onClick={() => updateMedium('LinkedIn')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='info' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=13930&format=png&color=000000" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>LinkedIn</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add LinkedIn accounts to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='LinkedIn' onChange={handleChange} checked={isSelectedMedium("LinkedIn")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Reddit')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=8weyx4k1jpJy&format=png&color=000000" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Reddit</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add Reddit accounts to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Reddit' onChange={handleChange} checked={isSelectedMedium("Reddit")} />
                </Box>
                <Box
                    onClick={() => updateMedium('X')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=phOKFKYpe00C&format=png&color=000000" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>X</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add X account/s to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='X' onChange={handleChange} checked={isSelectedMedium("X")} />
                </Box>
                <Box
                    onClick={() => updateMedium('Discord')}
                    sx={{ mb: 6, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <CustomAvatar skin='light' color='success' variant='rounded' sx={{ mr: 3, width: 48, height: 48 }}>
                            <img src="https://img.icons8.com/?size=32&id=30998&format=png&color=000000" />
                        </CustomAvatar>
                        <Box>
                            <Typography sx={{ color: 'text.secondary' }}>Discord</Typography>
                            <Typography variant='caption' sx={{ color: 'text.disabled' }}>
                                Add Discord account/s to manage from your application.
                            </Typography>
                        </Box>
                    </Box>
                    <Radio value='Discord' onChange={handleChange} checked={isSelectedMedium("Discord")} />
                </Box>
            </Box>
        </Box>
    )
}

export default TabDetails
